function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 -19)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  fill: "#FF9A00",
  cx: 155.5,
  cy: 174.5,
  r: 155.5
}), React.createElement("text", {
  fontFamily: "ArialRoundedMTBold, Arial Rounded MT Bold",
  fontSize: 300,
  fill: "#FFF"
}, React.createElement("tspan", {
  x: 106.049,
  y: 284
}, "!")));

var SvgMarkProblem = function SvgMarkProblem(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 311 311"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzExcHgiIGhlaWdodD0iMzExcHgiIHZpZXdCb3g9IjAgMCAzMTEgMzExIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1MiAoNjY4NjkpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPkdyb3VwIDI8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDMxLjAwMDAwMCwgLTE3Mi4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwMzEuMDAwMDAwLCAxNTMuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsLUNvcHkiIGZpbGw9IiNGRjlBMDAiIGN4PSIxNTUuNSIgY3k9IjE3NC41IiByPSIxNTUuNSI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICA8dGV4dCBpZD0iIS1jb3B5IiBmb250LWZhbWlseT0iQXJpYWxSb3VuZGVkTVRCb2xkLCBBcmlhbCBSb3VuZGVkIE1UIEJvbGQiIGZvbnQtc2l6ZT0iMzAwIiBmb250LXdlaWdodD0ibm9ybWFsIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgICAgICAgICA8dHNwYW4geD0iMTA2LjA0ODgyOCIgeT0iMjg0Ij4hPC90c3Bhbj4KICAgICAgICAgICAgICAgIDwvdGV4dD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
export { SvgMarkProblem as ReactComponent };